export default __webpack_public_path__ + "c4cbbf491488abf12acb16af54e5c204.png";